import * as React from 'react';
import { resolvePosition } from '../utils/resolvePosition';
export var Wrapper = function (_a) {
    var instances = _a.instances, onRemove = _a.onRemove, position = _a.position, _b = _a.isMessage, isMessage = _b === void 0 ? false : _b;
    var positionClass = resolvePosition(position);
    var prefix = isMessage ? 'message' : 'notification';
    var _class = isMessage ? 'wrapper-messages ' : 'wrapper-notifications ';
    return (React.createElement("div", { className: _class + positionClass }, instances.map(function (child) {
        var _a, _b;
        var closableClass = (child === null || child === void 0 ? void 0 : child.closable) ? ' ant-closable' : '';
        // @ts-ignore
        var className = (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.className) !== null && _b !== void 0 ? _b : '';
        return (React.createElement("div", { key: "".concat(prefix, "-").concat(child.key) }, React.cloneElement(child.content, {
            id: child.key,
            closable: child.closable,
            className: "ant-".concat(prefix, "-notice ").concat(child.animation, " ").concat(closableClass, " ").concat(className),
            onRemove: function () { return onRemove(child.key, position); }
        })));
    })));
};
